import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngForFilter',
  pure: true,
  standalone: false,
})
export class NgForFilterPipe implements PipeTransform {
  transform<T>(items: ReadonlyArray<T>, predicate: (item: T) => boolean): ReadonlyArray<T> {
    if (!items || !predicate) {
      return items;
    }
    return items.filter(item => predicate(item));
  }
}
